<section class="flowpay-intro-wrapper">
  <div class="box">
    <div class="box__left">
      <h1 class="box__subheading color-blue">{{ 'FLOWPAY.FLOWPAY_INTRO.SUB_HEADING' | translate }}</h1>

      <h2 class="box__heading color-gray box__heading {{ translate.currentLang }}"
        >{{ 'FLOWPAY.FLOWPAY_INTRO.HEADING' | translate }}
      </h2>

      <!-- list detail heading -->
      <div class="box__heading-detail-list" [innerHTML]="'FLOWPAY.FLOWPAY_INTRO.DETAIL' | translate: creditCardLogo">
      </div>

      <div class="btn-wrapper">
        <a
          class="btn-try-free flowbtn app-btn"
          href="https://form.flowaccount.com/request-payment"
          aria-label="Request payment"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ 'FLOWPAY.FLOWPAY_INTRO.BTN_REGISTER_FOR_FREE' | translate }}
        </a>
      </div>
    </div>
    <div class="box__right">
      <picture class="desktop">
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_intro_v4.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_intro_v4.jpg"
          width="420"
          height="280"
          loading="eager"
          alt="{{ getAltText }}"
          title="{{ getAltText }}"
          class="box__image"
        />
      </picture>
      <picture class="mobile">
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_intro_v4-mobile.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_intro_v4.jpg"
          width="330"
          height="220"
          loading="eager"
          alt="{{ getAltText }}"
          title="{{ getAltText }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
